import {
    allFetch
} from "../Domain";

/**
 * @description 待辦事項
 */
export const ToDoList = (() => {
    /**
     * @description 查詢待辦事項
     */
    const ToDoListSearch = async function (obj) {
        return await allFetch('ToDoList/ToDoListSearch', obj);
    }
    /**
     * @description 新增待辦事項
     */
    const ToDoListCreate = async function (obj = {
        url: '',
        request: '',
        execute_date: ''
    }) {
        return await allFetch('ToDoList/ToDoListCreate', obj);
    }
    /**
     * @description 修改待辦事項
     */
    const ToDoListUpdate = async function (obj = {
        execute_date: '',
        is_canceled:''
    }) {
        return await allFetch('ToDoList/ToDoListUpdate', obj);
    }
    /**
     * @description 新增待辦事項結果
     */
    const ToDoListLogCreate = async function (obj = {
        url: '',
        request: '',
        execute_date: ''
    }) {
        return await allFetch('ToDoList/ToDoListLogCreate', obj);
    }

    return {
        ToDoListSearch,
        ToDoListCreate,
        ToDoListUpdate,
        ToDoListLogCreate
    }
})();